import moment, { Moment } from 'moment-timezone';

/**
 * Formats any number to ¥12,345.67
 * @param amount
 * @returns amount in Japanese Yen (¥)
 */
const formatToCurrency = (amount: number) => {
  const formattedValue = new Intl.NumberFormat('ja-JP', {
    style: 'currency',
    currency: 'JPY',
    minimumFractionDigits: 2,
  })
    .format(Math.floor(Math.abs(amount)))
    .replace(/^./g, '\uffe5'); // use the full-width Yen character, as it's most supported

  const [beforeDecimal, afterDecimal] = formattedValue.split('.');

  const prefix = amount < 0 ? '-' : '';

  // If a value after the decimal point is 0, just return the whole number
  if (afterDecimal === '00') {
    return `${prefix}${beforeDecimal}`;
  }

  return `${prefix}${formattedValue}`;
};

const fullWidthToHalfWidth = (text: string) =>
  text.replace(/[\uFF10-\uFF19]/g, (c) =>
    String.fromCharCode(c.charCodeAt(0) - 0xfee0)
  );

export const formatMonthDate = (date: string | Moment, format = 'MM月DD日') => {
  return moment(date).tz('Asia/Tokyo').format(format);
};

export const formatYearMonthDate = (
  date: string | Moment,
  lng: 'en' | 'jp' = 'jp'
) => {
  const timezoneDate = moment(date).tz('Asia/Tokyo');

  if (lng === 'jp') {
    return timezoneDate.format('YYYY年MM月DD日');
  }

  return timezoneDate.format('YYYY/MM/DD');
};

export const formatYearMonth = (
  date: string | Moment,
  lng: 'en' | 'jp' = 'jp'
) => {
  const timezoneDate = moment(date).tz('Asia/Tokyo');

  if (lng === 'jp') {
    return timezoneDate.format('YYYY年M月');
  }

  return timezoneDate.format('YYYY/MM');
};

export const formatYear = (date: string | Moment) => {
  return moment(date).tz('Asia/Tokyo').format('YYYY年');
};

export { formatToCurrency, fullWidthToHalfWidth };
